import { render, staticRenderFns } from "./PackagingCodeView.vue?vue&type=template&id=b8a838fe&scoped=true&"
import script from "./PackagingCodeView.vue?vue&type=script&lang=js&"
export * from "./PackagingCodeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a838fe",
  null
  
)

export default component.exports